import { Redirect } from 'react-router-dom'

const RouteNotFound = () => {
  return <Redirect to={{ state: { notFoundError: true } }} />
}

RouteNotFound.displayName = 'RouteNotFound'

export default RouteNotFound
